import { ConsentGroup } from './OneTrust';
import { ScriptLoader } from './Script';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace Apple {
    interface AuthInitOptions {
      clientId: string;
      scope: string;
      redirectURI: string;
      state?: string;
      usePopup?: boolean;
    }

    interface Authorization {
      authorization: {
        state?: string;
        code: string;
        id_token: string;
      };
    }

    interface AuthorizationError {
      error: 'user_cancelled_authorize' | string;
    }

    interface Auth {
      init(options: AuthInitOptions): void;

      signIn(): Promise<Authorization>;
    }
  }

  interface Window {
    AppleID?: {
      auth: Apple.Auth;
    };
  }
}

const loader = new ScriptLoader(
  'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
  ConsentGroup.NECESSARY,
  'appleid-sdk',
);
let initialized = false;

export const isAppleSDKLoaded = () => loader.isLoaded;

export function loadAppleSDK(callback?: () => void) {
  let result;
  if (callback) {
    result = loader.then(callback);
  }
  loader.load();
  return result;
}

export function initAppleLogin(clientId: string, scope: string) {
  return new Promise<void>((resolve, reject) => {
    if (initialized) return resolve();
    if (!loader.isLoaded) return reject();

    window.AppleID.auth.init({
      clientId,
      scope,
      redirectURI: createAppleLoginRedirect(),
      usePopup: true,
    });
    initialized = true;
    resolve();
  });
}

export function createAppleLoginRedirect(): string {
  return process.env.GATSBY_APPLE_REDIRECT_URL;
}
